export const basicRatio = [
  { size: 48, lines: 2 },
  { size: 26, lines: 5 },
  { size: 16, lines: 8 }
];

export const modernRatio = [
  { size: 48, lines: 2 },
  { size: 26, lines: 4 },
  { size: 16, lines: 5 }
];

export const standardRatio = [
  { size: 48, lines: 2 },
  { size: 26, lines: 4 },
  { size: 16, lines: 5 }
];